var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 193,
    viewBox: "0 0 409 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11495_12645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.992 170.998L144.476 190.36L92.4564 242.707C91.6779 243.49 90.4115 243.494 89.628 242.716L72.9813 226.173C72.1978 225.394 72.1939 224.128 72.9725 223.344L124.992 170.998Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.77 153.597C161.009 153.484 162.049 154.518 161.944 155.757L158.258 199.365C158.115 201.057 156.06 201.812 154.855 200.615L114.957 160.967C113.753 159.769 114.495 157.71 116.186 157.556L159.77 153.597Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09 178.998L354.574 198.36L302.554 250.707C301.776 251.49 300.509 251.494 299.726 250.716L283.079 234.173C282.295 233.394 282.292 232.128 283.07 231.344L335.09 178.998Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.868 161.597C371.106 161.484 372.146 162.518 372.041 163.757L368.355 207.365C368.212 209.057 366.158 209.812 364.953 208.615L325.055 168.967C323.85 167.769 324.592 165.71 326.284 165.556L369.868 161.597Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.684 137.071L258.168 156.434L172.458 242.683C171.679 243.466 170.413 243.47 169.629 242.691L152.982 226.149C152.199 225.37 152.195 224.104 152.974 223.32L238.684 137.071Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.753 119.607C274.997 119.49 276.043 120.529 275.933 121.774L272.064 165.596C271.914 167.285 269.864 168.034 268.662 166.839L228.734 127.161C227.532 125.967 228.268 123.911 229.956 123.752L273.753 119.607Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0508 75.6533L96.9034 105.319L-24.3636 227.349C-25.1422 228.133 -26.4085 228.136 -27.192 227.358L-54.2073 200.511C-54.9908 199.733 -54.9948 198.466 -54.2162 197.683L67.0508 75.6533Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.655 40.928C131.023 40.6813 132.219 41.87 131.981 43.239L118.273 122.039C117.996 123.633 116.04 124.255 114.893 123.115L49.8875 58.5167C48.7403 57.3766 49.3505 55.417 50.9422 55.1298L129.655 40.928Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.051 84.6533L244.903 114.319L123.636 236.349C122.858 237.133 121.592 237.136 120.808 236.358L93.7927 209.511C93.0092 208.733 93.0052 207.466 93.7838 206.683L215.051 84.6533Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.655 49.928C279.023 49.6813 280.219 50.87 279.981 52.239L266.273 131.039C265.996 132.633 264.04 133.255 262.893 132.115L197.888 67.5167C196.74 66.3766 197.35 64.417 198.942 64.1298L277.655 49.928Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.051 99.6533L356.903 129.319L235.636 251.349C234.858 252.133 233.592 252.136 232.808 251.358L205.793 224.511C205.009 223.733 205.005 222.466 205.784 221.683L327.051 99.6533Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.655 64.928C391.023 64.6813 392.219 65.87 391.981 67.239L378.273 146.039C377.996 147.633 376.04 148.255 374.893 147.115L309.888 82.5167C308.74 81.3766 309.35 79.417 310.942 79.1298L389.655 64.928Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9766 115.668L112.461 135.031L5.45577 242.708C4.67717 243.492 3.41085 243.496 2.62735 242.717L-14.0194 226.175C-14.8029 225.396 -14.8068 224.13 -14.0282 223.346L92.9766 115.668Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.579 90.4438C136.969 90.1704 138.195 91.3885 137.93 92.7799L127.896 145.524C127.597 147.099 125.659 147.699 124.522 146.569L81.8756 104.189C80.7385 103.059 81.3263 101.118 82.8993 100.808L135.579 90.4438Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11495_12645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 409,
    height: 193,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGrp);
export default __webpack_public_path__ + "static/media/arrowGrp.758760a1169f1fea164eaa0a0d8c189d.svg";
export { ForwardRef as ReactComponent };